import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import HRLayout from "../../components/HrScheduleLayout.jsx"; // Import EmpScheduleLayout component
import { Button, Form, Alert } from "react-bootstrap";
import axios from "axios";
import "./hr-timing.css";
import Select from "react-select";

export default function EmpTiming() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [timingData, setTimingData] = useState({
    shiftStart: "",
    shiftEnd: "",
    breakStart: "",
    breakEnd: "",
  });

  const [shift, setShift] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("success");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTimingData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (timingData.shiftStart) {
      setShift(calculateShift(timingData.shiftStart));
    }
  }, [timingData.shiftStart]);

  const calculateShift = (shiftStart) => {
    const start = new Date(`1970-01-01T${shiftStart}:00`);
    return start.getHours() < 12 ? "AM" : "PM";
  };

  const shiftOptions = [
    { value: "AM", label: "Morning" },
    { value: "PM", label: "Evening" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { shiftStart, shiftEnd, breakStart, breakEnd } = timingData;
    const start = new Date(`1970-01-01T${shiftStart}:00`);
    const end = new Date(`1970-01-01T${shiftEnd}:00`);
    const breakIn = new Date(`1970-01-01T${breakStart}:00`);
    const breakOut = new Date(`1970-01-01T${breakEnd}:00`);

    if (start >= end || breakIn >= breakOut) {
      setAlertMessage("Please ensure all time fields are valid.");
      setAlertVariant("danger");
      setShowAlert(true);
      return;
    }

    const totalWorkHours = (end - start - (breakOut - breakIn)) / 3600000;

    try {
      const response = await axios.post(
        `https://backend.ems.hiradentallab.com/api/timings/add/${userId}`,
        {
          userId, // Explicitly pass userId as a string here
          shiftStart,
          shiftEnd,
          breakStart,
          breakEnd,
          totalHours: totalWorkHours,
          shift: calculateShift(shiftStart),
        }
      );
      setAlertMessage(response.data.message);
      setShowAlert(true);
      setAlertVariant("success");
      setTimeout(() => navigate("/hr-schedule"), 3000);
    } catch (error) {
      console.error("Error adding timing data:", error);
      setAlertMessage(
        error.response?.data?.message ||
          "An error occurred while adding timing data."
      );
      setAlertVariant("danger");
      setShowAlert(true);
    }
  };

  return (
    <HRLayout>
      <div className="emp-timing-container">
        {showAlert && (
          <Alert
            variant={alertVariant}
            onClose={() => setShowAlert(false)}
            dismissible
          >
            {alertMessage}
          </Alert>
        )}
        <Form className="emp-timing-form" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <Form.Group controlId="shiftStart">
                <Form.Label>
                  Check-IN <span className="required-asterisk">*</span>
                </Form.Label>
                <Form.Control
                  type="time"
                  name="shiftStart"
                  value={timingData.shiftStart}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group controlId="shiftEnd">
                <Form.Label>
                  Check-Out <span className="required-asterisk">*</span>
                </Form.Label>
                <Form.Control
                  type="time"
                  name="shiftEnd"
                  value={timingData.shiftEnd}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Form.Group controlId="breakStart">
                <Form.Label>
                  Break-IN <span className="required-asterisk">*</span>
                </Form.Label>
                <Form.Control
                  type="time"
                  name="breakStart"
                  value={timingData.breakStart}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group controlId="breakEnd">
                <Form.Label>
                  Break-Out <span className="required-asterisk">*</span>
                </Form.Label>
                <Form.Control
                  type="time"
                  name="breakEnd"
                  value={timingData.breakEnd}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </div>
          </div>
          <Button className="btn btn-primary mt-3" type="submit">
            Add
          </Button>
        </Form>
      </div>
      <div className="emp-shift-container">
        <Form.Group controlId="shift-select">
          <Form.Label>Selected Shift:</Form.Label>
          <Select
            value={shiftOptions.find((option) => option.value === shift)}
            isDisabled
            options={shiftOptions}
            placeholder="--Shift--"
          />
        </Form.Group>
      </div>
    </HRLayout>
  );
}
